import { Response } from 'src/app/interfaces/interface-bakend/response';
import { environment } from 'src/environments/environment';
import { AuthService } from '@services/auth/auth.service';
import { StorageService } from '@services/shared/storage.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { GuiMsjService } from '@services/shared/gui-msj.service';
import { SignoGerenciadora } from '../gerencias-interface/gerencias-interface';
import Swal from 'sweetalert2';

const URL_BACKEND = environment.urlBackend;

@Injectable({ providedIn: 'root' })
export class SignoGerenciasService {

    signoGerenciaSeleccionada: SignoGerenciadora;

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private guiMsjService: GuiMsjService,
        private authService: AuthService,
        private storageService: StorageService
    ) {}

    async create(gerencia: SignoGerenciadora): Promise<SignoGerenciadora> {
        const headers = new HttpHeaders({
            'x-token': await this.authService.loadJwToken(),
        });

        return new Promise(async (resolve, reject) => {
            await this.httpClient
                .post<Response>(`${URL_BACKEND}/signo-gerenciadoras`, gerencia, {
                    headers,
                })
                .subscribe(
                    (resp: Response) => {
                        Swal.close();

                        Swal.fire({
                            icon: 'success',
                            title: 'Gerencia guardada satisfactoriamente',
                            showConfirmButton: false,
                            timer: 1000,
                        });

                        this.router.navigate(['/gerenciadoras-listado']);
                        resolve(resp.response);
                    },
                    (error) => {
                        console.error(error);
                        this.guiMsjService.msjFormSubmit('crearGerenciaError');
                        this.router
                            .navigateByUrl('/', { skipLocationChange: true })
                            .then(async () => {
                                await this.router.navigateByUrl('/');
                            });
                        reject(error);
                    }
                );
        });
    }

    getGerenciaSeleccionada(): SignoGerenciadora {
        return this.signoGerenciaSeleccionada;
    }

    async getGerencias(): Promise<SignoGerenciadora[]> {
        return new Promise(async (resolve) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient
                .get<Response>(`${URL_BACKEND}/signo-gerenciadoras/findAll`, {
                    headers,
                })
                .subscribe((resp: Response) => {
                    resolve(resp.response);
                });
        });
    }

    async getGerenciaById(id: string): Promise<SignoGerenciadora> {
        return new Promise(async (resolve) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient
                .get<Response>(`${URL_BACKEND}/signo-gerenciadoras/findOne/${id}`, {
                    headers,
                })
                .subscribe((resp: Response) => {
                    resolve(resp.response);
                });
        });
    }
    
    async getAllGerenciasByEspecialidad(EspecialidadId: string): Promise<SignoGerenciadora[]> {
        return new Promise(async (resolve, reject) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });

            this.httpClient
                .get<Response>(`${URL_BACKEND}/signo-gerenciadoras/findAllByEspecialidad/${EspecialidadId}`, {
                    headers,
                })
                .subscribe((resp: Response) => {
                    resolve(resp.response);
                },
                (error: Error) => {
                    console.error(error);
                    reject(error.message);
                });
        });
    }

    async updateGerencia(_id: string, gerencia: SignoGerenciadora): Promise<SignoGerenciadora> {
        return new Promise(async (resolve) => {
            const headers = new HttpHeaders({
                'x-token': await this.authService.loadJwToken(),
            });
            this.httpClient
                .put<Response>(
                    `${URL_BACKEND}/signo-gerenciadoras/updateOne/${_id}`,
                    gerencia,
                    { headers }
                )
                .subscribe(
                    (resp: Response) => {
                        resolve(resp.response);
                    },
                    (error) => {
                        console.error(error);
                        this.guiMsjService.msjFormSubmit('gerenciaDuplicada');
                    }
                );
        });
    }

    setGerenciaSeleccionada(gerencia: SignoGerenciadora) {
        this.signoGerenciaSeleccionada = gerencia;
        // this.storageService.setGerencia(this.signoGerenciaSeleccionada);
    }
}